import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import IndexedDBService, { storeName } from "../../Utils/DBConfig";
import TinyTextEditior from "../UserInteractive/TinyTextEditior";
import { setCurrKirtanIndex, setKirtanIndex } from "../../Slice/KirtanIndexSlice";
import ConfirmBox from "../UserInteractive/ConfirmBox";
import { styled } from "@mui/material/styles";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { CircularProgress, Stack } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import PinModal from "../Modals/PinModal";
import handleContent from "../../services/kirtanContent.service";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const AddKirtanStepper = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const isEdit = window.location.pathname.split("/")[1] === "edit";

  const kirtanId = window.location.pathname.split("/")[2];

  const isDbInitialized = useSelector((state) => state.db.isDbInitialized);

  const [isValid, setIsValid] = useState(false);

  const [openPin, setOpenPin] = useState(false);

  const [kirtanData, setKirtanData] = useState([]);

  const [kirtanTitle, setKirtanTitle] = useState("");

  const [kirtanEnglishTitle, setKirtanEnglishTitle] = useState("");

  const [kirtanLines, setKirtanLines] = useState("");

  const [importData, setImportData] = useState();

  const [editorHtml, setEditorHtml] = useState("");

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const [showDatabaseUpdateConfirm, setShowDatabaseUpadaterConfirm] = useState(false);

  const [importingData, setImportingData] = useState(false);

  const APIurl = useSelector((state) => state.db.url);

  const getEditorContent = (kirtan) => setKirtanLines(kirtan);

  const getEditorHtml = (html) => setEditorHtml(html);

  const handleShowDatabaseUpdateConfirm = (x) => setShowDatabaseUpadaterConfirm(x);

  const handleShowDeleteConfirm = (x) => setShowDeleteConfirm(x);

  const getKirtanById = () => kirtanData.find((kirtan) => kirtan.id === +kirtanId);

  const handlePinModal = (value) => setOpenPin(value);

  const handelImportClick = async (event) => {
    try {
      setImportingData(true);
      let file = event.target.files[0]; // get the file from the event
      if (!file) {
        setImportingData(false);
        return;
      }

      let formData = new FormData();
      formData.append("file", file); // append the file to form data

      try {
        const URL = `${APIurl}/api/kirtan/html`;
        const response = await fetch(URL, {
          method: "POST",
          headers: {
            Authorization: sessionStorage.getItem("token") ? `Bearer ${sessionStorage.getItem("token")}` : "",
          },
          body: formData,
        });
        if (response.ok) {
          const result = await response.json();
          setImportData(
            result.data
              .replace(/(<p[^>]*align=")[^"]*("[^>]*>)/g, "$1center$2")
              .replace(/(<font[^>]*face=")[^"]*("[^>]*>)/g, "$1Ghanu_unicode_Guj$2")
              .replace(/અા/g, "આ")
              .replace(/અો/g, "ઓ")
              .replace(/અે/g, "એ")
              .replace(/જાે/g, "જો"),
          );
          // console.log('result): ', result.data.replace(/(<p[^>]*align=")[^"]*("[^>]*>)/g, '$1center$2').replace(/(<font[^>]*face=")[^"]*("[^>]*>)/g, '$1Ghanu$2'));
        } else {
          console.error("Failed to upload file:", response.statusText);
        }
        setImportingData(false);
      } catch (error) {
        setImportingData(false);
        console.error("Error uploading file:", error);
      }
    } catch (error) {
      console.log("error: ", error);
      setImportingData(false);
    }
  };

  const handlePinValue = async (value) => {
    sessionStorage.setItem("pinValue", value);
    setShowDatabaseUpadaterConfirm(false);
    handleDatabaseUpdate();
  };

  const handleSubmit = async () => {
    // let startFontFamilyTag = '<span style="font-family: Guj_Gopika_Two_Bold;">';
    // let endTag = '</span>';
    // let contentArr = kirtanLines.replace(/<p>|<\/p>|<div>|<\/div>/g, '<br>').split('<br>');
    // let content = contentArr.filter(line => {
    //   let strippedLine = line.replace(/<[^>]*>/g, '');
    //   let decodedLine = strippedLine.replace(/&nbsp;/gi, ' ').trim();
    //   return decodedLine !== '';
    // });
    // const finalContent = content.map((str, index) => {
    //   if (str.match(/font-family:[^;]+;/)) {
    //     let style = str.match(/<span\s+(?:style="[^"]*"\s*)?[^>]*>/s);
    //     startFontFamilyTag = style[0];
    //     return str;
    //   } else {
    //     let string = str.replace(/<\/span>/g, '');
    //     return (startFontFamilyTag + string + endTag);
    //   }
    // });

    const finalContent = handleContent(kirtanLines);

    const maxOrder = kirtanData.length > 0 ? Math.max(...kirtanData.map((k) => k.order || 0)) : 0;
    const DbData = {
      id: isEdit ? Number(kirtanId) : kirtanData.length > 0 ? kirtanData[kirtanData.length - 1]?.id + 1 : 0,
      page_no: getKirtanById()?.page_no || 0,
      title: kirtanTitle,
      english_title: kirtanEnglishTitle || "",
      content: finalContent,
      shortcuts: getKirtanById()?.shortcuts || {
        0: "1",
        1: "2",
        2: "3",
        3: "4",
        4: "5",
        5: "6",
        6: "7",
        7: "8",
        8: "9",
      },
      seq_id: getKirtanById()?.seq_id || 0,
      book_id: getKirtanById()?.book_id || 0,
      database_id: getKirtanById()?.database_id || 0,
      originalContent: kirtanLines,
      settings: {
        fontSize: getKirtanById()?.settings?.fontSize || "50px",
        fontWeight: getKirtanById()?.settings?.fontWeight || "500",
        color: getKirtanById()?.settings?.color || "#ffffff",
        backgroundColor: getKirtanById()?.settings?.backgroundColor || "#000000",
        height: getKirtanById()?.settings?.height || "100px",
        textShadowColor: getKirtanById()?.settings?.textShadowColor || "#ffffff",
        textShadowWidth: getKirtanById()?.settings?.textShadowWidth || "0px",
        isDualLineMode: getKirtanById()?.settings?.isDualLineMode || false,
      },
      favLines: getKirtanById()?.favLines || [0, 1],
      lineHistory: getKirtanById()?.lineHistory || [],
      selectedLine: 0,
      selectedPlate: getKirtanById()?.selectedPlate || 1,
      order: isEdit ? getKirtanById()?.order : maxOrder + 1,
    };

    if (isDbInitialized)
      if (!isEdit) {
        IndexedDBService.addItem(DbData, storeName)
          .then(() => {
            dispatch(setKirtanIndex(DbData.id));
            dispatch(setCurrKirtanIndex(0));
            navigate("/");
          })
          .catch((error) => console.error(error));
      } else {
        IndexedDBService.updateItem(DbData, storeName)
          .then(() => {
            navigate("/");
            dispatch(setCurrKirtanIndex(0));
          })
          .catch((error) => console.error(error));
      }
  };

  const handleDelete = () => {
    isDbInitialized &&
      IndexedDBService.deleteItem(Number(kirtanId))
        .then(() => {
          IndexedDBService.getAllData(storeName).then((data) => {
            dispatch(setKirtanIndex(data[0]?.id || 0));
            navigate("/");
          });
        })
        .catch((error) => console.error(error));
  };

  const handleExport = async () => {
    const preHtml =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    const postHtml = "</body></html>";
    const html = preHtml + editorHtml + postHtml;

    const blob = new Blob(["\ufeff", html], {
      type: "application/msword",
    });

    // Specify link url
    const url = "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

    // Specify file name
    let filename = "content.docx";

    // Create download link element
    const downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = url;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  };

  const showAlertToast = (type, message) => {
    switch (type) {
      case "warn":
        toast.warn(message);
        break;
      case "success":
        toast.success(message);
        break;
      case "error":
        toast.error(message);
        break;
      case "Alert":
        toast.alert(message);
        break;
      default:
    }
  };

  const handleDatabaseUpdate = async () => {
    const pin = sessionStorage.getItem("pinValue");
    if (pin) {
      const database_id = getKirtanById()?.database_id;
      const submittingData = {
        english_title: kirtanEnglishTitle,
        content: editorHtml,
        pin: pin,
      };
      const updateURL = `${APIurl}/api/kirtan/update/${database_id}`;

      const authToken = sessionStorage.getItem("token");
      axios
        .post(updateURL, submittingData, {
          headers: {
            Authorization: authToken ? `Bearer ${authToken}` : "",
          },
        })
        .then((response) => {
          return response.data;
        })
        .then(async (data) => {
          if (data.status === 200) {
            handleSubmit();
            handleShowDatabaseUpdateConfirm(false);
          } else showAlertToast("error", data.message);
        })
        .catch((error) => {
          handleShowDatabaseUpdateConfirm(false);
          showAlertToast("warn", error);
          console.log(error);
        });
    } else {
      handlePinModal(true);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key !== "ArrowUp" && event.key !== "ArrowDown" && event.key !== "ArrowLeft" && event.key !== "ArrowRight" && event.key !== "q") {
      if (isEdit && event.key === "Delete") handleShowDeleteConfirm(true);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);

    return () => window.removeEventListener("keydown", handleKeyPress);
  }, []);

  useEffect(() => {
    setIsValid(kirtanLines.trim() !== "" && kirtanLines !== "fgg" && kirtanTitle !== "");
  }, [kirtanLines, kirtanTitle]);

  useEffect(() => {
    isDbInitialized && IndexedDBService.getAllData(storeName).then((data) => setKirtanData(data));
  }, [isDbInitialized]);

  useEffect(() => {
    if (Object.keys(kirtanData).length > 0) {
      const currKirtanData = Object.values(kirtanData).find((kirtan) => kirtan.id === Number(kirtanId));
      currKirtanData && setKirtanTitle(currKirtanData.title);
      currKirtanData && setKirtanEnglishTitle(currKirtanData.english_title || "");
    }
  }, [kirtanData, kirtanId]);

  useEffect(() => {
    if (isEdit)
      if (kirtanData[kirtanId]?.originalContent === kirtanLines) setIsValid(false);
      else setIsValid(true);
  }, [isEdit, kirtanLines, kirtanData, kirtanId]);

  return (
    <div className="w-full h-full bg-gray-50 overflow-hidden">
      {openPin && <PinModal openPin={openPin} handlePinModal={handlePinModal} handlePinValue={handlePinValue} />}
      <div className="container pt-3">
        <Box sx={{ width: "100%" }} className="relative">
          <Box className="flex justify-between item-center w-full gap-3 pb-2 absolute top-0 z-50">
            <Box className="flex justify-start items-center gap-3">
              <Typography className="text-[20px] bg-white" sx={{ fontWeight: "500" }}>
                Title
              </Typography>
              <TextField
                sx={{ borderRadius: "999px" }}
                InputProps={{
                  style: {
                    borderRadius: "999px",
                    backgroundColor: "#FFFFFF",
                  },
                }}
                value={kirtanTitle}
                onChange={(e) => setKirtanTitle(e.target.value)}
                id="Kirtan_Title_Sulekh"
                size="small"
                className="my-2"
                autoComplete="off"
              />
              <TextField
                sx={{ borderRadius: "999px" }}
                InputProps={{
                  style: {
                    borderRadius: "999px",
                    backgroundColor: "#FFFFFF",
                  },
                }}
                value={kirtanEnglishTitle}
                onChange={(e) => setKirtanEnglishTitle(e.target.value)}
                id="Kirtan_English_Title_Sulekh"
                size="small"
                className="my-2"
                autoComplete="off"
              />
            </Box>

            <Box className="flex justify-end item-end gap-3 pb-2">
              <Button sx={{ borderRadius: "25px", textTransform: "none", minWidth: "48px" }} component="label" variant="contained" size="small">
                {importingData ? (
                  <Stack
                    className={`flex justify-center items-center transition-all duration-300 ease-in-out cursor-pointe bg-inherit no-select`}
                    direction={{ xs: "column", sm: "row" }}
                  >
                    <CircularProgress sx={{ color: "white" }} size={25} />
                  </Stack>
                ) : (
                  <CloudDownloadOutlinedIcon fontSize="large" />
                )}
                <input
                  type="file"
                  style={{ display: "none" }} // make sure the input is hidden
                  onChange={handelImportClick} // add onChange handler
                  accept=".rtf"
                />
                <VisuallyHiddenInput type="file" />
              </Button>
              <Button
                sx={{ borderRadius: "25px", textTransform: "none", minWidth: "48px" }}
                variant="contained"
                onClick={handleExport}
                color="primary"
                disabled={editorHtml !== ""}
              >
                <CloudUploadOutlinedIcon fontSize="large" />
              </Button>
              <Button
                sx={{ borderRadius: "25px", textTransform: "none", minWidth: "48px" }}
                variant="contained"
                onClick={() => {
                  handleShowDatabaseUpdateConfirm(true);
                }}
                disabled={!isEdit || editorHtml === "" || kirtanEnglishTitle === ""}
                color="primary"
              >
                <i className="fa-solid fa-database fa-xl"></i>
              </Button>
              <Button
                sx={{ borderRadius: "25px", textTransform: "none", minWidth: "100px" }}
                variant="outlined"
                color="inherit"
                onClick={() => {
                  navigate("/");
                }}
              >
                Cancel
              </Button>
              <Button
                sx={{ borderRadius: "25px", textTransform: "none", minWidth: "100px" }}
                variant="contained"
                onClick={handleSubmit}
                color="primary"
                disabled={!isValid}
              >
                {isEdit ? "Update" : "Save"}
              </Button>
              {isEdit && (
                <Button
                  sx={{ borderRadius: "25px", minWidth: "100px", textTransform: "none" }}
                  variant="contained"
                  color="error"
                  onClick={() => handleShowDeleteConfirm(true)}
                >
                  Delete
                </Button>
              )}
            </Box>
          </Box>
          <div className="pt-16">
            <TinyTextEditior getEditorContent={getEditorContent} importData={importData} kirtanId={kirtanId} getEditorHtml={getEditorHtml} />
          </div>
        </Box>
        <ConfirmBox open={showDeleteConfirm} handleClose={handleShowDeleteConfirm} handleConfirm={handleDelete} />
        <ConfirmBox
          open={showDatabaseUpdateConfirm}
          handleClose={handleShowDatabaseUpdateConfirm}
          handleConfirm={handleDatabaseUpdate}
          title={"Confirm Database Update"}
          msg={"Are you sure you want update in database?"}
        />
      </div>
    </div>
  );
};

export default AddKirtanStepper;
